import { createMuiTheme } from "@material-ui/core/styles";

export const prodTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#B60C0F"
    },
    secondary: {
      main: "#53b9c7"
    }
  },
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: "#212121",
        color: "#B6C3CC"
      }
    },
    MuiCardHeader: {
      root: {
        // more neutral
        backgroundColor: "#ebeeef",

        // more emphasis
        // backgroundColor: "#d2d7db",
        height: "15px",
        border: ".5px solid #e3e6e8"
      },
      title: {
        fontSize: "16px",
        fontWeight: 500,
        color: "#404040"
      }
    },
    MuiButton: {
      containedSecondary: {
        color: "#fff"
      },
      containedPrimary: {
        backgroundColor: "#448088",
        color: "#fff"
      },
      textSecondary: {
        color: "#448088"
      }
    },
    MuiIconButton: {
      colorSecondary: "#fff"
    }
  }
});
export const devTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#1E392A"
    },
    secondary: {
      main: "#FFAD05"
    }
  },
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: "#0C3B5A",
        color: "#B6C3CC"
      }
    },
    MuiCardHeader: {
      root: {
        backgroundColor: "#ebeeef",
        height: "15px",
        border: ".5px solid #e3e6e8"
      },
      title: {
        fontSize: "16px",
        fontWeight: 500,
        color: "#404040"
      }
    },
    MuiButton: {
      containedSecondary: {
        color: "#fff"
      }
    }
  }
});

export const styles = {
  app: {
    width: "auto"
  },
  header: {
    transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100
  },
  content: {
    transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    marginTop: 64,
    paddingTop: "1rem",
    paddingBottom: "1rem"
  },
  drawer: {
    marginLeft: 222
  }
};
